import {getMethod, patchMethod, postMethod, putMethod} from '~/api'
import {clone} from '@/utils/helpers'

async function get(request, cancelToken) {
    const requestCopy = clone(request)

    if (request.id && authStore.person?.companyId === request.id) {
        requestCopy.relationship = 'OWN'
    }

    return await getMethod('/api/companies', requestCopy, cancelToken)
}

async function post(request) {
    return await postMethod('/api/companies', request)
}

async function put(id, request) {
    return await putMethod(`/api/companies/${id}`, request)
}

async function patch(id, request) {
    return await patchMethod(`/api/companies/${id}`, request)
}

export {get, post, put, patch}
